"use client";

import Image from "next/image";

interface ClickableImageProps {
  src: string; // Path to the image
  alt: string; // Alt text for accessibility
  width?: number; // Optional: Width of the image
  height?: number; // Optional: Height of the image
  redirectUrl?: string; // URL to navigate when the image is clicked
}

export default function ClickableImage({
  src,
  alt,
  width = 600,
  height = 400,
  redirectUrl,
}: ClickableImageProps) {
  const handleClick = () => {
    window.location.href = redirectUrl!;
  };

  return (
    <div className="text-center">
      <Image
        src={src}
        alt={alt}
        width={width}
        height={height}
        unoptimized
        className="rounded-lg shadow-lg cursor-pointer hover:opacity-80"
        onClick={handleClick}
      />
    </div>
  );
}
